import { MainColor } from '../../palette/colors';

export const getTableTheme = () => {
  return {
    common: {
      mainTextColor: 'coolGrey60' as MainColor,
      activeTextColor: 'forest50' as MainColor,
      hoverTextColor: 'forest60' as MainColor,
      backgroundColor: 'white95' as MainColor,
      border: 'coolGrey30' as MainColor,
      rowBorder: 'coolGrey10' as MainColor,
      checkbox: 'coolGrey60' as MainColor,
      activeCheckbox: 'navy60' as MainColor,
      focusBorder: 'navy40' as MainColor,
    },
    body: {
      mainTextColor: 'navy95' as MainColor,
      rowBackground: 'navy10' as MainColor,
      groupRowBackground: 'coolGrey5' as MainColor,
    },
    footer: {
      bgIndicator: 'forest50' as MainColor,
      backgroundColor: 'coolGrey5' as MainColor,
      arrow: 'navy80' as MainColor,
    },
    header: {
      alertIcon: 'red50' as MainColor,
    },
    additionalColors: {
      hoverBg: 'blueGrey10' as MainColor,
      selectedBg: 'navy10' as MainColor,
      grayBg05: 'coolGrey5' as MainColor,
      grayBg10: 'coolGrey10' as MainColor,
    },
  };
};

export type TableTheme = ReturnType<typeof getTableTheme>;
